var _mask, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagicContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 42,
    viewBox: "0 0 161 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3470_4199",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1719 27.4279C38.4463 35.8817 30.4888 42 21.0967 42C9.45395 42 0.015625 32.598 0.015625 21C0.015625 9.40202 9.45395 0 21.0967 0C30.4888 0 38.4463 6.11829 41.1719 14.5721C43.887 6.11829 51.814 0 61.1699 0H139.633C151.231 0 160.633 9.40202 160.633 21C160.633 32.598 151.231 42 139.633 42H61.1699C51.814 42 43.887 35.8817 41.1719 27.4279Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1719 27.4279C38.4463 35.8817 30.4888 42 21.0967 42C9.45395 42 0.015625 32.598 0.015625 21C0.015625 9.40202 9.45395 0 21.0967 0C30.4888 0 38.4463 6.11829 41.1719 14.5721C43.887 6.11829 51.814 0 61.1699 0H139.633C151.231 0 160.633 9.40202 160.633 21C160.633 32.598 151.231 42 139.633 42H61.1699C51.814 42 43.887 35.8817 41.1719 27.4279Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1719 27.4279L41.648 27.275L41.1728 25.7957L40.696 27.2745L41.1719 27.4279ZM41.1719 14.5721L40.696 14.7255L41.1728 16.2043L41.648 14.725L41.1719 14.5721ZM40.696 27.2745C38.0354 35.5267 30.2665 41.5 21.0967 41.5V42.5C30.711 42.5 38.8572 36.2367 41.6478 27.5813L40.696 27.2745ZM21.0967 41.5C9.72827 41.5 0.515625 32.32 0.515625 21H-0.484375C-0.484375 32.8759 9.17962 42.5 21.0967 42.5V41.5ZM0.515625 21C0.515625 9.67998 9.72827 0.5 21.0967 0.5V-0.5C9.17962 -0.5 -0.484375 9.12406 -0.484375 21H0.515625ZM21.0967 0.5C30.2665 0.5 38.0354 6.47325 40.696 14.7255L41.6478 14.4187C38.8572 5.76332 30.711 -0.5 21.0967 -0.5V0.5ZM41.648 14.725C44.2986 6.47197 52.0375 0.5 61.1699 0.5V-0.5C51.5904 -0.5 43.4755 5.76461 40.6959 14.4192L41.648 14.725ZM61.1699 0.5H139.633V-0.5H61.1699V0.5ZM139.633 0.5C150.955 0.5 160.133 9.67816 160.133 21H161.133C161.133 9.12588 151.507 -0.5 139.633 -0.5V0.5ZM160.133 21C160.133 32.3218 150.955 41.5 139.633 41.5V42.5C151.507 42.5 161.133 32.8741 161.133 21H160.133ZM139.633 41.5H61.1699V42.5H139.633V41.5ZM61.1699 41.5C52.0375 41.5 44.2986 35.528 41.648 27.275L40.6959 27.5808C43.4755 36.2354 51.5904 42.5 61.1699 42.5V41.5Z",
    fill: "url(#paint0_linear_3470_4199)",
    mask: "url(#path-1-inside-1_3470_4199)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3470_4199",
    x1: 60.8343,
    y1: 0.0000354345,
    x2: 147.794,
    y2: 11.6576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC",
    stopOpacity: 0.27
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicContainer);
export default __webpack_public_path__ + "static/media/magic-container.480fdd39fd2778841ed37103331dfb41.svg";
export { ForwardRef as ReactComponent };